// extracted by mini-css-extract-plugin
export default {"card":"Card_card__UvFRt","card_header":"Card_card_header__1N8AM","title":"Card_title__4Lp+p"};